// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3870":"17b45fdb","6582":"9e54791b"}[chunkId] + ".chunk.css";
};